import React, { useEffect, useRef, useState } from 'react';
import { AxiosError } from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import StatusMessages, { StatusMessage } from '../../components/StatusMessages';
import styles from './ActivateUser.module.css';
import { activateUser } from '../../api/accounts';
import { LOGIN_ROUTE } from '../../config/constants';

export interface ActivateUserRedirectProps {};

// takes in activation token and activates user
// shows status of activation
const ActivateUser = (props: ActivateUserRedirectProps): JSX.Element | null => {
  // list of status messages
  const [statusMessages, setStatusMessages] = useState<StatusMessage[]>([
    {
      message: 'Activating account ...',
      status: 'warning'
    }
  ]);

  // ref to avoid activating user multiple times on multiple renders
  const activateUserCalled = useRef<boolean>(false);

  const navigate = useNavigate();
  // get token from URL parameters
  const { token } = useParams();

  // set document title
  useEffect(() => {
    document.title = 'Activate Account | Sigmoid Academy';
  }, []);

  // activate user on render
  useEffect(() => {
    if (activateUserCalled.current) {
      return
    }

    activateUserCalled.current = true;

    // redirect to login page if token not found in URL parameteres
    if (token == null) {
      navigate(LOGIN_ROUTE);
      return;
    }

    // activate user
    activateUser(
      token
    // navigate to login route with success status messages on success
    ).then(() => {
      navigate(
        LOGIN_ROUTE,
        {
          state: {
            statusMessages: [
              {
                message: 'Account activated, you can now log in',
                status: 'success'
              },
            ]
          }
        }
      );
    // display danger status messages on failure
    }).catch((error: AxiosError) => setStatusMessages((previousMessages: StatusMessage[]) => [
      {
        message: 'Unknown error occurred',
        status: 'error'
      }
    ]));
  }, [navigate, token]);

  return (
    <div>
      <MainLayout>
        <div className={styles.mainContainer}>
          <StatusMessages items={statusMessages} />
        </div>
      </MainLayout>
    </div>
  );
};

export default ActivateUser;